import React from "react";

export default function Section({ id, title, subtitle, right, fullBleed = false, bgClass = "", children }) {
  return (
    <section id={id} className={`${bgClass} overflow-x-clip`}>
      <div className={`mx-auto min-w-0 w-full md:w-[85%] max-w-7xl px-3 sm:px-4 md:px-0 py-4 md:py-5`}>
        <div className="mb-2.5 flex items-end justify-between gap-3">
          <div className="min-w-0">
            <h2 className="font-sans text-lg md:text-xl font-bold tracking-tight text-slate-900">{title}</h2>
            {subtitle && (
              <p className="mt-0.5 font-sans text-xs text-slate-600 sm:text-sm">{subtitle}</p>
            )}
          </div>
          {right}
        </div>
        {children}
      </div>
    </section>
  );
}
